import {Steps as IntroJSSteps} from 'intro.js-react';
import type {StepsProps} from 'intro.js-react';
import {useConfigValue} from '../../hooks/useConfigValue';

export {type StepsProps};

export const Steps = ({enabled, ...otherProps}: StepsProps) => {
  const introEnabled = useConfigValue('introEnabled');

  return <IntroJSSteps enabled={introEnabled && enabled} {...otherProps} />;
};
